import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: []
  }),
  getters: {
    list: state => state.list,
    map: state => state.list.reduce((map, item) => {
      map[item.id] = Object.freeze(item)
      return map
    }, {})
  },
  mutations: {
    list (state, list) {
      state.list = Object.freeze(list)
    }
  },
  actions: {
    request ({commit}) {
      return Vue.prototype.$api.DeviceCategory.getList().then(deviceCategories => {
        // commit('list', deviceCategories.filter(deviceCategory => deviceCategory.parentId))
        commit('list', deviceCategories)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/DeviceCategory.js